import React from 'react'
import { Main, MainBody, MainTop, MainTopTitle } from '@/components/Layout'
import Resx from '@/components/Resx'

export function PageForbidden403 () {
  return (
    <Main>
      <MainTop>
        <MainTopTitle>
          <Resx name='Common.PageForbiddenTitle' />
        </MainTopTitle>
      </MainTop>

      <MainBody transparent>
        <div><Resx name='Common.PageForbiddenContent' /></div>
      </MainBody>
    </Main>
  )
}



// WEBPACK FOOTER //
// ./src/components/403.js